<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :hide-default-footer="true"
    >
      <template
        slot="item.selected"
        slot-scope="props"
      >
        <v-checkbox
          disabled
          v-model="props.item.selected"
        ></v-checkbox>
      </template>
      <template slot="item.name" slot-scope="props">
        <div>{{props.item.name}}</div>
        <div class="caption my-2" v-if="props.item.children && props.item.children.length">{{getChildrenText(props.item.children)}}</div>
      </template>
      <template
        slot="item.price"
        slot-scope="props"
      >
        <div :class="{ 'line-throught': props.item.assignmentsPrice && props.item.assignmentsPrice < props.item.price }">
          {{ props.item.price | currency | withCurrencyCode }}
        </div>
        <div v-if="props.item.assignmentsPrice"
          :class="{ 'line-throught': props.item.assignmentsPrice && props.item.assignmentsPrice >= props.item.price }"
          class="my-2"
        >
          {{ props.item.assignmentsPrice | currency | withCurrencyCode }}
        </div>
      </template>
    </v-data-table>
    <p class="text-md-center" v-if="items.length==0">Detta yrke har ingen distansutbildning eller så saknas kurskoppling</p>
  </div>
</template>

<script>
export default {
  name: 'ApplicationDistanceEducationView',

  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed:{
    headers(){
      const headers = [];
      if(this.canSelect){
        headers.push({ text: 'Välj', value: 'selected', sortable: false })
      }
      headers.push(
        { text: 'Kod', value: 'id', sortable: false },
        { text: 'Teoripaket', value: 'name', sortable: false },
        { text: 'Pris', value: 'price', sortable: false, width: '100' },
      )
      return headers
    },

    canSelect() {
      return this.items.some(i => Object.hasOwn(i, 'selected'))
    }

  },
  methods:{
    getChildrenText(children){
      return children.map(a => a.name).join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
.line-throught{
  text-decoration: line-through;
}
</style>